module.exports = __webpack_public_path__ + "assets/fa-solid-900.ec763292e583294612f124c0b0def500.svg";